import { domain as domainFactory } from "@nextgisweb/pyramid/i18n/gettext";

const domain = domainFactory("auth");

export const {
    gettext,
    gettextf,
    ngettext,
    ngettextf,
    pgettext,
    pgettextf,
    npgettext,
    npgettextf,
} = domain;

export default domain;
